<template>
  <div>
    <div id="modal" ref="modal" class="modal" :class="{'is-active': isActive }">
      <div @click="hideModal" class="modal-background"></div>
      <div class="modal-card">
        <header class="modal-card-head">
          <p class="modal-card-title">How much should I spend on Google Ads?</p>
          <button @click="hideModal" class="delete" aria-label="close"></button>
        </header>
        <section class="modal-card-body">
          <h3 class="is-size-4">How much you should spend depends on three factors</h3>
          <br />
          <div class="list is-hoverable">
              <a class="list-item">What are your goals for new leads, revenue?</a>
              <a class="list-item">How much traffic do you need to reach your goals?</a>
              <a class="list-item">What is the gap in spending between where you’re at now and where you need to be?</a>
          </div>
          <h3 class="is-size-4">What are your goals for leads or revenue?</h3>
          <p>The first step in the process can be eye opening. Ask yourself, what is your goal for new leads or revenue?</p>
          <br />
          <p>If the goal to grow leads is much larger from current results, the amount to spend in Google Adwords to achieve that target is equally significant.</p>
          <br />
          <h3>Now we work our way through the rest of the numbers with cost per click and conversion rate to better understand what budet to set.</h3>
          <!-- Content ... -->
        </section>
        <footer class="modal-card-foot">
          <!-- <button class="button is-success">Save changes</button> -->
          <button @click="hideModal" class="button">Cancel</button>
        </footer>
      </div>
    </div>
    </div>
</template>

<script>
export default {
  props: ['isActive'],
  methods: {
    hideModal () {
      let element = document.getElementById('modal')
      element.classList.remove('is-active')
    }
  }
}
</script>
